import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function AlertDialog(props) {
  const {
    open,
    setOpen,
    showCancel = true,
    isModal = false,
    titleText,
    contentText,
    cancelText,
    confirmText,
    handleConfirm,
  } = props;

  const handleClose = () => {
    setOpen(false);
  };

  const handleDialogClose = (event, reason) => {
    if (isModal && (reason === "backdropClick" || reason === "escapeKeyDown")) {
      return;
    }
    handleClose();
  };

  const handleConfirmClick = () => {
    if (typeof handleConfirm === "function") {
      handleConfirm();
    }
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{titleText}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {contentText}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {showCancel ? (
          <Button onClick={handleClose}>{cancelText}</Button>
        ) : null}
        <Button onClick={handleConfirmClick} color="primary" autoFocus>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
